import React from 'react';

const Section = ({
  as: Component = 'section',
  className = '',
  surface = 'default',
  children,
}) => {
  const classes = ['c-section', `c-section--${surface}`, className]
    .filter(Boolean)
    .join(' ');

  return <Component className={classes}>{children}</Component>;
};

export default Section;
